import { Component, OnInit } from '@angular/core';
import { ReferenceDataLabels } from 'rome-library';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'boi-junk-emails',
  templateUrl: './junk-emails.component.html'
})
export class JunkEmailsComponent implements OnInit {
  public readonly referenceDataLabels = ReferenceDataLabels;

  constructor(private readonly headerService: HeaderService) {}

  ngOnInit(): void {
    this.headerService.setHeaderTitle('');
  }
}
